import type { FocusEvent } from "react";

// Grid toolbars that may not fit (768–1023px, long locales) scroll inside, never the page.
export const TOOLBAR_SCROLL =
  "min-w-0 max-w-full overflow-x-auto overscroll-x-contain [scrollbar-width:thin] [scrollbar-color:rgba(45,182,240,0.35)_transparent] [&>*]:shrink-0";

// Keyboard focus brings a partly hidden control fully into the toolbar's view.
export function revealFocused(e: FocusEvent<HTMLElement>) {
  (e.target as HTMLElement).scrollIntoView?.({ block: "nearest", inline: "nearest" });
}
